import { useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useCompose } from '../lib/compose';
import { Bell } from './Bell';
import { SearchBar } from './SearchBar';
import { TopbarMe } from './TopbarMe';

export function Topbar() {
    const { authed, login } = useAuth();
    const { openCompose } = useCompose();
    const headerRef = useRef<HTMLElement | null>(null);

    // Mobile only: retract on scroll-down, ONLY reveal on real scroll-up.
    // Previous version used a `toggle` that flipped false on any non-down
    // event (including "stopped scrolling") which made the bar snap back
    // as soon as the user lifted their thumb. Now we hide/show on discrete
    // direction transitions with a small threshold to prevent jitter.
    useEffect(() => {
        let last = 0;
        const THRESHOLD = 8;  // px — how far the user must actually move
        function onScroll() {
            const el = headerRef.current;
            if (!el) return;
            const y = window.scrollY;
            const delta = y - last;
            if (Math.abs(delta) < THRESHOLD) return;   // ignore tiny wobbles
            if (delta > 0 && y > 60) {
                el.classList.add('topbar-hidden');     // scrolled down → hide
            } else if (delta < 0) {
                el.classList.remove('topbar-hidden');  // real scroll-up → show
            }
            last = y;
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header ref={headerRef} className="topbar">
            <Link to="/" className="brand">
                OnHere<span className="sub">· Vredehoek</span>
            </Link>
            <nav className="topnav">
                <NavLink to="/"           end>Paper</NavLink>
                {authed && <NavLink to="/diary"        >Diary</NavLink>}
                {authed && <NavLink to="/places"       >Places</NavLink>}
                {authed && <NavLink to="/classifieds"  >Classifieds</NavLink>}
                {authed && <NavLink to="/messages"     >Messages</NavLink>}
            </nav>
            <div className="topbar-actions">
                {authed && <SearchBar />}
                {authed && (
                    <button
                        type="button"
                        className="topbar-btn"
                        aria-label="New post"
                        title="New post"
                        onClick={openCompose}
                    >
                        <svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="10" y1="4" x2="10" y2="16" />
                            <line x1="4" y1="10" x2="16" y2="10" />
                        </svg>
                    </button>
                )}
                {authed && <Bell />}
                {authed ? <TopbarMe /> : (
                    <button type="button" className="plain" onClick={login}>Log in</button>
                )}
            </div>
        </header>
    );
}
